import { format, isValid, parse } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatMessageDate = (date: string): string => {
  const parsedDate = parse(date, "dd/MM/yyyy", new Date());
  const day = format(parsedDate, "d");
  const month = format(parsedDate, "MMMM", { locale: ptBR }).toLowerCase();
  const year = format(parsedDate, "yyyy");
  return `${day} de ${month} de ${year}`;
};

export const formatMessageTime = (
  date: Date | string | number | undefined | null,
  fullFormat = false,
): string => {
  // Se a data for undefined ou null, retorna o valor padrão
  if (date == null) {
    return "--:--";
  }

  try {
    let dateObj: Date;

    if (date instanceof Date) {
      dateObj = date;
    } else if (typeof date === "number") {
      dateObj = new Date(date);
    } else {
      // Se for string, verificar se tem fuso horário
      let dateStr = String(date);
      // Se for ISO (contém T) mas não tem fuso (Z ou +/-, ou offset no final), assume UTC vindo do servidor
      if (
        dateStr.includes("T") &&
        !dateStr.includes("Z") &&
        !dateStr.includes("+") &&
        !/-\d{2}:\d{2}$/.test(dateStr)
      ) {
        dateStr += "Z";
      }
      dateObj = new Date(dateStr);
    }

    // Verifica se a data é válida
    if (!isValid(dateObj)) {
      console.warn("Data inválida recebida em formatMessageTime:", date);
      return "--:--";
    }

    if (fullFormat) {
      // Formata no padrão local do browser
      return format(dateObj, "dd/MM/yyyy', 'HH:mm", { locale: ptBR });
    }

    // Formata apenas hora:minuto no padrão local do browser
    return format(dateObj, "HH:mm", { locale: ptBR });
  } catch (error) {
    console.error("Erro ao formatar data em formatMessageTime:", error);
    return "--:--";
  }
};
